// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORMS_DEFAULT_REQUIRED_FIELD_ERROR = "Toto pole je povinn\u00e9.";
